import React from "react";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Avatar,
  Flex,
  Box,
  Text,
} from "@chakra-ui/react";

import { Link } from "react-router-dom";

import Cookies from "js-cookie";

import axios from "../../utils/axios";

import { useDispatch } from "react-redux";

import { dispatchSignOut } from "../../redux/actions/userActions";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);

  const handleSignout = async () => {
    try {
      await axios.get("/api/user/signout");
      localStorage.removeItem("firstSignin");
      Cookies.remove("refreshtoken");
      dispatch(dispatchSignOut());
      navigate("/", { replace: true });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Flex alignItems="center" justifyContent="flex-end" mt="2">
      <Box mr="2">
        <Text fontSize="sm">{`${user.firstName ? user?.firstName : ""} ${
          user.lastName ? user?.lastName : ""
        }`}</Text>
      </Box>
      <Menu>
        <MenuButton>
          <Avatar
            size="sm"
            name={`${user.firstName ? user?.firstName : ""} ${
              user.lastName ? user?.lastName : ""
            }`}
            bg="orange"
          />
        </MenuButton>
        <MenuList>
          <MenuGroup>
            <MenuItem>Profile</MenuItem>
            <MenuItem>
              <Link to="/settings">My Account</Link>
            </MenuItem>
          </MenuGroup>
          <MenuDivider />
          <MenuGroup>
            {/* <MenuItem>Docs</MenuItem> */}
            <MenuItem onClick={handleSignout}>Sign out</MenuItem>
          </MenuGroup>
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Header;
